! function(t, o, e) {
    "use strict";
    var i = t(o),
        n = o.document,
        s = t(n),
        a = function() {
            for (var t, o = 3, e = n.createElement("div"), i = e.getElementsByTagName("i"); e.innerHTML = "<!--[if gt IE " + ++o + "]><i></i><![endif]-->", i[0];);
            return o > 4 ? o : t
        }(),
        r = function() {
            var t = o.pageXOffset !== e ? o.pageXOffset : "CSS1Compat" == n.compatMode ? o.document.documentElement.scrollLeft : o.document.body.scrollLeft,
                i = o.pageYOffset !== e ? o.pageYOffset : "CSS1Compat" == n.compatMode ? o.document.documentElement.scrollTop : o.document.body.scrollTop;
            "undefined" == typeof r.x && (r.x = t, r.y = i), "undefined" == typeof r.distanceX ? (r.distanceX = t, r.distanceY = i) : (r.distanceX = t - r.x, r.distanceY = i - r.y);
            var s = r.x - t,
                a = r.y - i;
            r.direction = s < 0 ? "right" : s > 0 ? "left" : a <= 0 ? "down" : a > 0 ? "up" : "first", r.x = t, r.y = i
        };
    i.on("scroll", r), t.fn.style = function(e) {
        if (!e) return null;
        var i, s = t(this),
            a = s.clone().css("display", "none");
        a.find("input:radio").attr("name", "copy-" + Math.floor(100 * Math.random() + 1)), s.after(a);
        var r = function(t, e) {
            var i;
            return t.currentStyle ? i = t.currentStyle[e.replace(/-\w/g, function(t) {
                return t.toUpperCase().replace("-", "")
            })] : o.getComputedStyle && (i = n.defaultView.getComputedStyle(t, null).getPropertyValue(e)), i = /margin/g.test(e) ? parseInt(i) === s[0].offsetLeft ? i : "auto" : i
        };
        return "string" == typeof e ? i = r(a[0], e) : (i = {}, t.each(e, function(t, o) {
            i[o] = r(a[0], o)
        })), a.remove(), i || null
    }, t.fn.extend({
        hcSticky: function(n) {
            return 0 == this.length ? this : (this.pluginOptions("hcSticky", {
                top: 0,
                bottom: 0,
                bottomEnd: 0,
                innerTop: 0,
                innerSticker: null,
                className: "sticky",
                wrapperClassName: "wrapper-sticky",
                stickTo: null,
                responsive: !0,
                followScroll: !0,
                offResolutions: null,
                onStart: t.noop,
                onStop: t.noop,
                on: !0,
                fn: null
            }, n || {}, {
                reinit: function() {
                    t(this).hcSticky()
                },
                stop: function() {
                    t(this).pluginOptions("hcSticky", {
                        on: !1
                    }).each(function() {
                        var o = t(this),
                            e = o.pluginOptions("hcSticky"),
                            i = o.parent("." + e.wrapperClassName),
                            n = o.offset().top - i.offset().top;
                        o.css({
                            position: "absolute",
                            top: n,
                            bottom: "auto",
                            left: "auto",
                            right: "auto"
                        }).removeClass(e.className)
                    })
                },
                off: function() {
                    t(this).pluginOptions("hcSticky", {
                        on: !1
                    }).each(function() {
                        var o = t(this),
                            e = o.pluginOptions("hcSticky"),
                            i = o.parent("." + e.wrapperClassName);
                        o.css({
                            position: "relative",
                            top: "auto",
                            bottom: "auto",
                            left: "auto",
                            right: "auto"
                        }).removeClass(e.className), i.css("height", "auto")
                    })
                },
                on: function() {
                    t(this).each(function() {
                        t(this).pluginOptions("hcSticky", {
                            on: !0,
                            remember: {
                                offsetTop: i.scrollTop()
                            }
                        }).hcSticky()
                    })
                },
                destroy: function() {
                    var o = t(this),
                        e = o.pluginOptions("hcSticky"),
                        n = o.parent("." + e.wrapperClassName);
                    o.removeData("hcStickyInit").css({
                        position: n.css("position"),
                        top: n.css("top"),
                        bottom: n.css("bottom"),
                        left: n.css("left"),
                        right: n.css("right")
                    }).removeClass(e.className), i.off("resize", e.fn.resize).off("scroll", e.fn.scroll), o.unwrap()
                }
            }), n && "undefined" != typeof n.on && (n.on ? this.hcSticky("on") : this.hcSticky("off")), "string" == typeof n ? this : this.each(function() {
                var n = t(this),
                    c = n.pluginOptions("hcSticky"),
                    l = function() {
                        var t = n.parent("." + c.wrapperClassName);
                        return t.length > 0 && (t.css({
                            height: n.outerHeight(!0),
                            width: function() {
                                var o = t.style("width");
                                return o.indexOf("%") >= 0 || "auto" == o ? ("border-box" == n.css("box-sizing") || "border-box" == n.css("-moz-box-sizing") ? n.css("width", t.width()) : n.css("width", t.width() - parseInt(n.css("padding-left") - parseInt(n.css("padding-right")))), o) : n.outerWidth(!0)
                            }()
                        }), t)
                    }() || function() {
                        var o = n.style(["width", "margin-left", "left", "right", "top", "bottom", "float", "display"]),
                            e = n.css("display"),
                            i = t("<div>", {
                                class: c.wrapperClassName
                            }).css({
                                display: e,
                                height: n.outerHeight(!0),
                                width: function() {
                                    return o.width.indexOf("%") >= 0 || "auto" == o.width && "inline-block" != e && "inline" != e ? (n.css("width", parseFloat(n.css("width"))), o.width) : "auto" != o.width || "inline-block" != e && "inline" != e ? "auto" == o["margin-left"] ? n.outerWidth() : n.outerWidth(!0) : n.width()
                                }(),
                                margin: o["margin-left"] ? "auto" : null,
                                position: function() {
                                    var t = n.css("position");
                                    return "static" == t ? "relative" : t
                                }(),
                                float: o.float || null,
                                left: o.left,
                                right: o.right,
                                top: o.top,
                                bottom: o.bottom,
                                "vertical-align": "top"
                            });
                        return n.wrap(i), 7 === a && 0 === t("head").find("style#hcsticky-iefix").length && t('<style id="hcsticky-iefix">.' + c.wrapperClassName + " {zoom: 1;}</style>").appendTo("head"), n.parent()
                    }();
                if (!n.data("hcStickyInit")) {
                    n.data("hcStickyInit", !0);
                    var f = !(!c.stickTo || !("document" == c.stickTo || c.stickTo.nodeType && 9 == c.stickTo.nodeType || "object" == typeof c.stickTo && c.stickTo instanceof("undefined" != typeof HTMLDocument ? HTMLDocument : Document))),
                        p = c.stickTo ? f ? s : "string" == typeof c.stickTo ? t(c.stickTo) : c.stickTo : l.parent();
                    n.css({
                        top: "auto",
                        bottom: "auto",
                        left: "auto",
                        right: "auto"
                    }), i.load(function() {
                        n.outerHeight(!0) > p.height() && (l.css("height", n.outerHeight(!0)), n.hcSticky("reinit"))
                    });
                    var d = function(t) {
                            n.hasClass(c.className) || (t = t || {}, n.css({
                                position: "fixed",
                                top: t.top || 0,
                                left: t.left || l.offset().left
                            }).addClass(c.className), c.onStart.apply(n[0]), l.addClass("sticky-active"))
                        },
                        u = function(t) {
                            t = t || {}, t.position = t.position || "absolute", t.top = t.top || 0, t.left = t.left || 0, "fixed" != n.css("position") && parseInt(n.css("top")) == t.top || (n.css({
                                position: t.position,
                                top: t.top,
                                left: t.left
                            }).removeClass(c.className), c.onStop.apply(n[0]), l.removeClass("sticky-active"))
                        },
                        h = function(o) {
                            if (c.on && n.is(":visible")) {
                                if (n.outerHeight(!0) >= p.height()) return void u();
                                var e, s = c.innerSticker ? t(c.innerSticker).position().top : c.innerTop ? c.innerTop : 0,
                                    a = l.offset().top,
                                    h = p.height() - c.bottomEnd + (f ? 0 : a),
                                    m = l.offset().top - c.top + s,
                                    g = n.outerHeight(!0) + c.bottom,
                                    y = i.height(),
                                    v = i.scrollTop(),
                                    w = n.offset().top,
                                    b = w - v;
                                if ("undefined" != typeof c.remember && c.remember) {
                                    var k = w - c.top - s;
                                    return void(g - s > y && c.followScroll ? k < v && v + y <= k + n.height() && (c.remember = !1) : c.remember.offsetTop > k ? v <= k && (d({
                                        top: c.top - s
                                    }), c.remember = !1) : v >= k && (d({
                                        top: c.top - s
                                    }), c.remember = !1))
                                }
                                v > m ? h + c.bottom - (c.followScroll && y < g ? 0 : c.top) <= v + g - s - (g - s > y - (m - s) && c.followScroll && (e = g - y - s) > 0 ? e : 0) ? u({
                                    top: h - g + c.bottom - a
                                }) : g - s > y && c.followScroll ? b + g <= y ? "down" == r.direction ? d({
                                    top: y - g
                                }) : b < 0 && "fixed" == n.css("position") && u({
                                    top: w - (m + c.top - s) - r.distanceY
                                }) : "up" == r.direction && w >= v + c.top - s ? d({
                                    top: c.top - s
                                }) : "down" == r.direction && w + g > y && "fixed" == n.css("position") && u({
                                    top: w - (m + c.top - s) - r.distanceY
                                }) : d({
                                    top: c.top - s
                                }) : u()
                            }
                        },
                        m = !1,
                        g = !1,
                        y = function() {
                            if (w(), v(), c.on) {
                                var t = function() {
                                    "fixed" == n.css("position") ? n.css("left", l.offset().left) : n.css("left", 0)
                                };
                                if (c.responsive) {
                                    g || (g = n.clone().attr("style", "").css({
                                        visibility: "hidden",
                                        height: 0,
                                        overflow: "hidden",
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        marginTop: 0,
                                        marginBottom: 0
                                    }), l.after(g));
                                    var o = l.style("width"),
                                        e = g.style("width");
                                    "auto" == e && "auto" != o && (e = parseInt(n.css("width"))), e != o && l.width(e), m && clearTimeout(m), m = setTimeout(function() {
                                        m = !1, g.remove(), g = !1
                                    }, 250)
                                }
                                if (t(), n.outerWidth(!0) != l.width()) {
                                    var i = "border-box" == n.css("box-sizing") || "border-box" == n.css("-moz-box-sizing") ? l.width() : l.width() - parseInt(n.css("padding-left")) - parseInt(n.css("padding-right"));
                                    i = i - parseInt(n.css("margin-left")) - parseInt(n.css("margin-right")), n.css("width", i)
                                }
                            }
                        };
                    n.pluginOptions("hcSticky", {
                        fn: {
                            scroll: h,
                            resize: y
                        }
                    });
                    var v = function() {
                        if (c.offResolutions) {
                            t.isArray(c.offResolutions) || (c.offResolutions = [c.offResolutions]);
                            var o = !0;
                            t.each(c.offResolutions, function(t, e) {
                                e < 0 ? i.width() < e * -1 && (o = !1, n.hcSticky("off")) : i.width() > e && (o = !1, n.hcSticky("off"))
                            }), o && !c.on && n.hcSticky("on")
                        }
                    };
                    v(), i.on("resize", y);
                    var w = function() {
                        var n = !1;
                        t._data(o, "events").scroll != e && t.each(t._data(o, "events").scroll, function(t, o) {
                            o.handler == c.fn.scroll && (n = !0)
                        }), n || (c.fn.scroll(!0), i.on("scroll", c.fn.scroll))
                    };
                    w()
                }
            }))
        }
    })
}(jQuery, this),
function(t, o) {
    "use strict";
    t.fn.extend({
        pluginOptions: function(e, i, n, s) {
            return this.data(e) || this.data(e, {}), e && "undefined" == typeof i ? this.data(e).options : (n = n || i || {}, "object" == typeof n || n === o ? this.each(function() {
                var o = t(this);
                o.data(e).options ? o.data(e, t.extend(o.data(e), {
                    options: t.extend(o.data(e).options, n || {})
                })) : (o.data(e, {
                    options: t.extend(i, n || {})
                }), s && (o.data(e).commands = s))
            }) : "string" == typeof n ? this.each(function() {
                "undefined" != typeof t(this).data(e) && t(this).data(e).commands[n].call(this)
            }) : this)
        }
    })
}(jQuery);;

  
    

(function(f) {
    if ("undefined" === typeof wc_single_product_params) {
        return false
    }
    var c = parseInt(f(document.body).css("paddingTop"), 10);
    c = f(".header-sticky-wrapper").length ? c + f(".header-sticky-wrapper").height() : c;
    f(document.body).on("init", "#wc-product-collapse", function() {
        var h = window.location.hash,
            g = window.location.href;
        if (0 <= h.toLowerCase().indexOf("comment-") || "#reviews" === h || 0 < g.indexOf("comment-page-") || 0 < g.indexOf("cpage=")) {
            f("#heading-reviews").trigger("click")
        }
    }).on("click", "a.woocommerce-review-link", function() {
        f("#heading-reviews").trigger("click")
    }).on("click", "#respond span.stars i", function() {
        var g = f(this);
        if (g.hasClass("active")) {
            return false
        }
        g.closest("#respond").find("#rating").val(g.text());
        g.addClass("active").siblings().removeClass("active").closest(".stars").addClass("selected");
        return false
    }).on("submit", "#respond #commentform", function() {
        if ("undefined" !== typeof wc_single_product_params && !f(this).find("#rating ").val() && wc_single_product_params.review_rating_required === "yes") {
            window.alert(wc_single_product_params.i18n_required_rating_text);
            return false
        }
    });
    f("#wc-product-collapse").trigger("init");

    function d(h) {
        var l = f(".stick-in-parent");
        var k = null;
        if (l.length) {
            var i = l.closest(".wrapper-sticky"),
                j = i.parent();
            if (l.height() !== j.height()) {
                i.css({
                    height: l.height()
                })
            }
            if (l.height() > j.height()) {
                k = 0;
                var m = j.offset().top,
                    g = j.offset().top + j.height();
                if (l.offset().top < m) {
                    k = m - i.offset().top
                } else {
                    if ((l.offset().top + l.height()) > g) {
                        k = g - l.height() - i.offset().top
                    }
                }
                if (k < 0) {
                    k = 0
                }
            }
            console.log("123");
            if (null !== k) {
                if (l.hasClass("sticky")) {
                    k = k + i.offset().top - f(window).scrollTop()
                }
                l.animate({
                    top: k
                }, {
                    complete: function() {
                        f(".stick-in-parent").hcSticky("reinit");
                        f(window).trigger("scroll");
                        if ("shown" === h.type && "undefined" !== wcSingleParams && wcSingleParams.scroll_to_tab) {
                            f("html, body").animate({
                                scrollTop: f(h.target).parent().offset().top - c
                            })
                        }
                    }
                })
            } else {
                if ("shown" === h.type && "undefined" !== wcSingleParams && !!wcSingleParams.scroll_to_tab) {
                    f("html, body").animate({
                        scrollTop: f(h.target).parent().offset().top - c
                    })
                }
            }
        }
    }
    f(".wc-product-collapse .panel-collapse").on("hidden.bs.collapse", d).on("shown.bs.collapse", function(g) {
        d(g);
        if (!f(".stick-in-parent").length && "undefined" !== wcSingleParams && !!wcSingleParams.scroll_to_tab) {
            c = parseInt(f(document.body).css("paddingTop"), 10);
            c = f(".header-sticky-wrapper").length ? c + f(".header-sticky-wrapper").height() : c;
            f("html, body").animate({
                scrollTop: f(g.target).parent().offset().top - c
            })
        }
        f(".wc-product-collapse .panel-collapse").on("hidden.bs.collapse", d)
    }).on("show.bs.collapse", function() {
        f(".wc-product-collapse .panel-collapse").off("hidden.bs.collapse", d)
    });
    f(".wc-product-collapse .panel-collapse:last").on("shown.bs.collapse", function() {
        f(this).closest(".collapse-panel").addClass("shown")
    }).on("hidden.bs.collapse", function() {
        f(this).closest(".collapse-panel").removeClass("shown")
    });
    f(".stick-in-parent").hcSticky({
        top: c + 20
    });
   
   
  
   
})(jQuery);;
